import { render } from "./internship-candidates.vue?vue&type=template&id=6721dd3e"
import script from "./internship-candidates.vue?vue&type=script&lang=js"
export * from "./internship-candidates.vue?vue&type=script&lang=js"
script.render = render

export default script